import { useContext } from 'react'

import {
  Center,
  Heading,
  Link,
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { ScoresContext } from '../routes/ScoreListing'
import { ScoreWithRef } from '../types'

function ScoreResults() {
  const context = useContext(ScoresContext)

  if (!context) {
    return <div>Loading...</div>
  }

  const { filteredScores } = context

  return (
    <Stack mt={20}>
      <Center>
        <Heading>Results</Heading>
      </Center>
      <TableContainer w="100%">
        <Table variant="simple">
          <TableCaption>
            You can copy these results into the AddNewScores sheet in the Rocksmith 2014
            Championship google sheet:&nbsp;
            <Link>
              https://docs.google.com/spreadsheets/d/1WN-m8wF0lVkQ4cLWHBa009SkqDoPk0xN-C4-llcrXXs/edit#gid=2138541559
            </Link>
          </TableCaption>
          <Thead>
            <Tr textAlign="center">
              <Th w={15}>Name</Th>
              <Th w={30}>Song</Th>
              <Th w={10}>Path</Th>
              <Th w={5}>%</Th>
              <Th w={5}>Streak</Th>
              <Th w={10}>Score</Th>
              <Th w={3}>Status</Th>
              <Th w={3}>Index</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredScores.map((score: ScoreWithRef, ix: number) => {
              return (
                <Tr key={score.uniqueId}>
                  <Td>{score.author}</Td>
                  <Td>
                    {score.inputSong
                      ? score.inputArtist + ' - ' + score.inputSong
                      : score.classifiedArtist + ' - ' + score.classifiedSong}
                  </Td>
                  <Td>{score.inputPath || score.path}</Td>
                  <Td textAlign="center" isNumeric>
                    {score.inputAccuracy || score.accuracy}{' '}
                  </Td>
                  <Td textAlign="center" isNumeric>
                    {score.inputStreak || score.longestStreak}{' '}
                  </Td>
                  <Td textAlign="center" isNumeric>
                    {score.inputAbsoluteScore || score.absoluteScore}{' '}
                  </Td>
                  <Td textAlign="center">{score.status}</Td>
                  <Td textAlign="center">{score.ix}</Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default ScoreResults
